/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Field to sort by.
*/
export enum BackupJobSortField {
  BACKUP_JOB_SORT_CREATED_TIME = 'createdTime',
  BACKUP_JOB_SORT_START_TIME = 'startTime',
  BACKUP_JOB_SORT_END_TIME = 'endTime'
}
